import * as PropTypes from "prop-types"
import styled from "styled-components"
import CarsList from "components/CarsList"
import { SectionContainer } from "components/styled/Grid"
import Link from "components/Link"
import { PrimaryButton } from "components/styled/Buttons/PrimaryButton"
import Intro from "./Intro"

const ListWrapper = styled.div`
  margin-bottom: 50px;
`

export default function Offers({ cars, page, show, section }) {
  const { show_button, button_text, button_url } = section

  return (
    <SectionContainer>
      <ListWrapper className="preview">
        <CarsList pageName={page} cars={cars} Intro={() => <Intro section={section} />} show={show} />
      </ListWrapper>
      {show_button && <Link href={button_url || '#'} page={button_url ? undefined : "stock"}>
        <PrimaryButton as="a" size="xxl" shadow>
          {button_text}
        </PrimaryButton>
      </Link>}
    </SectionContainer>
  )
}

Offers.propTypes = {
  cars: PropTypes.array.isRequired,
  page: PropTypes.string.isRequired,
  show: PropTypes.object.isRequired,
  section: PropTypes.object.isRequired
}
